<template>
  <div class="dashboard-overview">
    <BalancePanel />
    <TotalTransactionDataPannelAgent @changeShowType="changeShowType" />
    <div class="data-container">
      <div class="data-container-title">
        {{ $t('dashboard.transaction_trends') }}
        <el-tooltip v-if="$store.getters.isPii" placement="bottom">
          <div slot="content">
            <span>{{ $t('tips.current_time_zone') }}</span>
          </div>
          <span><svg-icon icon-class="icon-font-warning" style="width: 22px;color: #3855F1;cursor: pointer;" /></span>
        </el-tooltip>
      </div>
      <div class="data-container-search">
        <span>{{ $t('components.date') }}:</span>
        <el-select v-model="activeColor" class="search-frame mb-10" size="small" clearable @change="onClickchangeTimes">
          <el-option
            v-for="(item,index) in dateArr"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-select v-model="showType" class="search-frame  mb-10" size="small" clearable>
          <el-option
            v-for="(item,index) in showTypeTransaction === 'second'? transaction_payin: transaction"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="getCharData">{{ $t('components.search') }}</el-button>
      </div>
    </div>
    <div class="bar-container">
      <bar-chart v-loading="loading" :char-data="charData" />
    </div>

  </div>
</template>

<script>
import { fetchPaymentData, fetchDisbursementData } from '@/api/dashboard/dashboard'
import BalancePanel from './BalancePanel'
import BarChart from './BarChart'
import TotalTransactionDataPannelAgent from './TotalTransactionDataPannelAgent'

export default {
  name: 'Dashboard-Overview',
  components: {
    BalancePanel,
    BarChart,
    TotalTransactionDataPannelAgent
  },
  data() {
    return {
      charData: {
        payAmountY: [],
        timesX: [],
        disAmountY: []
      },
      transaction: [
        { label: this.$t('dashboard.transaction_count'), value: 'number' },
        { label: this.$t('dashboard.transaction_amount'), value: 'amount' }],
      transaction_payin: [
        { label: this.$t('dashboard.transaction_count'), value: 'number' },
        { label: this.$t('dashboard.transaction_amount'), value: 'amount' },
        { label: this.$t('dashboard.refund_number'), value: 'refund_number' },
        { label: this.$t('dashboard.refund_amount'), value: 'refund_amount' }],
      activeColor: 'week',
      showType: 'number',
      showTypeTransaction: '',
      loading: false,
      pickerOptions: {
        disabledDate: this.disabledDate
      }
    }
  },
  computed: {
    dateArr() {
      return [
        { label: this.$t('dashboard.week'), value: 'week' },
        { label: this.$t('dashboard.month'), value: 'month' }
      ]
    }
  },
  watch: {
    '$store.getters.language'() {
      this.getCharData()
    }
  },
  mounted() {
    const { token } = this.$store.getters
    if (token) {
      this.getCharData()
    }
  },
  methods: {
    disabledDate(time) {
      return time.getTime() > Date.now()
    },
    // 获取支付和代付数据
    getCharData() {
      const params = { range: (this.activeColor || 'day').toUpperCase() }
      if (this.loading) {
        return
      }
      this.loading = true
      Promise.all([fetchPaymentData(params), fetchDisbursementData(params)]).then((res) => {
        const [payData = {}, disData] = res
        const { code: payCode, data: charPayY } = payData
        const { code: disCode, data: charDisY } = disData
        if (payCode === 10000 && disCode === 10000) {
          // 获取支付金额y轴数据
          const totalAmouts = []
          const totalNumbers = []
          const toDivide100 = this.$options.filters['toDivide100']
          const payAmountY = charPayY.map(item => {
            const itemAmout = toDivide100(item.total_amount)
            totalAmouts.push(itemAmout)
            return itemAmout
          })
          // 获取支付笔数y轴数据
          const payNumberY = charPayY.map(item => {
            const itemNumber = item.daily_count
            totalNumbers.push(itemNumber)
            return itemNumber
          })
          // 获取代付金额y轴数据
          const disAmountY = charDisY.map((item, index) => {
            const itemAmout = toDivide100(item.total_amount)
            totalAmouts[index] = totalAmouts[index] + itemAmout
            return itemAmout
          })
          // 获取代付笔数y轴数据
          const disNumberY = charDisY.map((item, index) => {
            const itemNumber = item.daily_count
            totalNumbers[index] = totalNumbers[index] + itemNumber
            return itemNumber
          })
          // 获取x轴数据
          const timesX = charPayY.map(item => {
            if (item.create_date_str && item.create_date_str.includes('-')) {
              return item.create_date_str.split('-').slice(1).join('/')
            } else {
              return item.create_date_str
            }
          })

          if (this.showType === 'number') {
            this.charData = {
              payY: payNumberY,
              disY: disNumberY,
              // allY: totalNumbers,
              timesX,
              config: {
                yAxisName: this.$t('dashboard.number'),
                seriesName: [this.$t('dashboard.payin_number'), this.$t('dashboard.payout_number'), 'all number']
              }
            }
          }
          if (this.showType === 'amount') {
            this.charData = {
              payY: payAmountY,
              disY: disAmountY,
              // allY: totalAmouts,
              timesX,

              config: {
                yAxisName: this.$t('dashboard.amount'),
                seriesName: [this.$t('dashboard.payin_amount'), this.$t('dashboard.payout_amount'), 'all amount']
              }
            }
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onClickchangeTimes(dateStr) {
      if (!dateStr) {
        this.activeColor = 'week'
      }
    },
    onClickSearchBtn() {
      this.getCharData()
    },
    changeShowType(value) {
      this.showTypeTransaction = value
    }
  }
}
</script>

<style lang="scss" scoped>
  .dashboard-overview {
    margin: 40px 57px 50px 32px;
  }
  .data-container{
    display: flex;
    justify-content: space-between;
    padding: 32px 0;
    .data-container-title{
      font-weight: 700;  font-family: 'Inter-Bold';
      font-size: 24px;
      line-height: 1.2;
      color: #1D3A71;
    }
    .data-container-search{
      .search-frame{
        margin-right: 24px;
      }
      span{
        margin-right: 16px;
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;
        color: #4B5567;
      }
    }
  }
  .bar-container{
    border: 1.5px solid #D3D7DF;
    border-radius: 12px;
    padding-bottom: 15px;
  }
  // @media screen and (max-width: 376px) {
  //   .dashboard{
  //       &-container {
  //         .bottomContainer{
  //           .timesContainer{
  //             margin: 0;
  //           }
  //           .bar-container{
  //             width: 100%;
  //             overflow: scroll;
  //           }
  //         }
  //       }

  //   }
  // }
</style>
